var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "draggable",
            {
              staticClass: "upload-draggable",
              on: { start: _vm.start, end: _vm.end },
              model: {
                value: _vm.fileList,
                callback: function ($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList",
              },
            },
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item + index,
                    staticClass: "itemI",
                    on: {
                      mouseenter: function ($event) {
                        return _vm.mouseenter($event, index)
                      },
                      mouseleave: _vm.mouseleave,
                    },
                  },
                  [
                    _c("el-image", {
                      staticClass: "image",
                      attrs: {
                        src: item.url,
                        "preview-src-list": [item],
                        fit: "cover",
                      },
                    }),
                    _c("div", { staticClass: "mark" }, [
                      _c("i", {
                        staticClass: "el-icon-zoom-in",
                        staticStyle: {
                          color: "white",
                          "font-size": "20px",
                          "margin-right": "10px",
                          "z-index": "9999",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handlePictureCardPreview(item)
                          },
                        },
                      }),
                      _c("i", {
                        staticClass: "el-icon-delete",
                        staticStyle: { color: "white", "font-size": "20px" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(item, index)
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                )
              }),
              _vm.fileList.length < _vm.limit
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        limit: _vm.limit,
                        action: "",
                        accept: "image/*",
                        "before-upload": _vm.beforeAvatarUpload,
                        "http-request": _vm.uploadFile,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        "file-list": _vm.fileList,
                        "on-preview": _vm.handlePictureCardPreview,
                        "show-file-list": false,
                        multiple: "",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }